'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
const STAGES = [{
  label: 'Awareness',
  color: 'bg-[#ff5a36]',
  width: 'w-full'
}, {
  label: 'Trial',
  color: 'bg-[#ff8a3d]',
  width: 'w-[85%]'
}, {
  label: 'Consideration',
  color: 'bg-[#ffc857]',
  width: 'w-[68%]'
}, {
  label: 'Intent',
  color: 'bg-[#8bd3a8]',
  width: 'w-[52%]'
}, {
  label: 'Purchase',
  color: 'bg-[#4fc3a1]',
  width: 'w-[38%]'
}, {
  label: 'Loyalty',
  color: 'bg-[#159a84]',
  width: 'w-[26%]'
}];
export function DemandTeaser() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pointer-events-none absolute inset-0" aria-hidden="true"><div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[#ff5a36]/20 blur-[100px]" /><div className="absolute -bottom-32 -right-24 h-80 w-80 rounded-full bg-[#4fc3a1]/15 blur-[100px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="block"><span className="underline decoration-white/60 underline-offset-4">Create</span>{" "}Demand.</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="block text-[#ff8a3d]"><span className="underline decoration-[#ff8a3d]/60 underline-offset-4">Convert</span>{" "}Demand.</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><h2 className="text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">{t1}{t2}<span className="block text-[#ff5a36]"><span className="underline decoration-[#ff5a36]/60 underline-offset-4">Compound</span>{" "}Demand.</span></h2><p className="mt-5 max-w-lg text-lg leading-relaxed text-gray-300">Your job is to get noticed, get tried, and be what consumers choose over everything else.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">{t3}<div className="space-y-3"><p className="mb-4 text-xs font-black uppercase tracking-[0.14em] text-gray-300">Consumers go through a journey with your brand and products</p>{STAGES.map(_temp)}</div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-white/10 bg-white/5 sm:grid-cols-3">{[["Create", "Get people to know and want your product"], ["Convert", "Turn interest into purchases"], ["Compound", "Earn repeat buys and recommendations"]].map(_temp2)}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="relative isolate overflow-hidden bg-gray-950 py-16 sm:py-20 lg:py-24">{t0}<div className="relative mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12">{t4}{t5}<div className="mt-10 text-center"><Link href="/demand" className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-[#ff5a36] px-7 py-3.5 text-base font-black text-white shadow-lg shadow-red-500/20 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">Become a Demand Master<ArrowRight className="h-5 w-5" aria-hidden="true" /></Link></div></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp2(t0) {
  const [title, desc] = t0;
  return <div key={title} className="px-6 py-5"><p className="text-lg font-black text-white">{title}</p><p className="mt-1 text-sm text-gray-400">{desc}</p></div>;
}
function _temp(stage) {
  return <div key={stage.label} className={`${stage.width} ${stage.color} flex h-11 items-center rounded-sm px-4 text-sm font-black text-gray-950`}>{stage.label}</div>;
}